export const userInitialValues = (entity = {}) => {
    return ({
        name: entity ? entity?.name : "",
        username: entity ? entity?.username : "",
        password: "",
    });
};
